import { Skeleton } from "@/components/ui/skeleton";
import { GlassCard } from "@/components/ui/glass-card";
import { useIsMobile } from "@/hooks/use-mobile";

/**
 * Compact loading skeletons that mirror the real layout of the Devices
 * page (status cards + search + row list) so mobile users don't see the
 * page reflow once data lands.
 */
export const DeviceListSkeleton = () => {
  const isMobile = useIsMobile();
  const statusCount = 4;
  const rowCount = isMobile ? 5 : 8;

  return (
    <div className="space-y-4 w-full" aria-busy="true" aria-label="Loading devices">
      {/* Status cards — match compact 2×2 (mobile) / 1×4 (desktop) grid */}
      <div
        className={`grid ${isMobile ? "grid-cols-2 gap-3" : "grid-cols-1 md:grid-cols-4 gap-6"}`}
      >
        {Array.from({ length: statusCount }).map((_, i) => (
          <GlassCard key={i} variant="subtle" hover={false} className={isMobile ? "p-3" : "p-6"}>
            <Skeleton className={isMobile ? "h-3 w-16 mb-2" : "h-4 w-24 mb-3"} />
            <Skeleton className={isMobile ? "h-6 w-10" : "h-8 w-16"} />
          </GlassCard>
        ))}
      </div>

      {/* Search bar */}
      <Skeleton className="h-10 w-full rounded-full" />

      {/* Row list — mirrors MobileDeviceList card row layout */}
      <div className="space-y-2">
        {Array.from({ length: rowCount }).map((_, i) => (
          <div
            key={i}
            className="flex items-center gap-3 p-3 rounded-lg border border-border bg-card"
          >
            <Skeleton className="h-10 w-10 rounded-lg shrink-0" />
            <div className="flex-1 space-y-2 min-w-0">
              <Skeleton className="h-4 w-2/3" />
              <Skeleton className="h-3 w-1/2" />
            </div>
            <Skeleton className="h-6 w-6 rounded shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DeviceListSkeleton;
